import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Home, Search, PlusCircle, User, Coffee } from 'lucide-react';
import { cn } from '@/lib/utils';

const tabs = [
  { path: '/', icon: Home, label: 'Home' },
  { path: '/search', icon: Search, label: 'Search' },
  { path: '/add', icon: PlusCircle, label: 'Add Review' },
  { path: '/my', icon: User, label: 'My Page' },
];

export default function NavBar() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#1C1209] border-b border-[#3a2a18]">
      <div className="relative flex items-center h-14 px-5 max-w-5xl mx-auto">

        {/* Logo - desktop only */}
        <Link to="/" className="hidden md:flex items-center gap-2.5 shrink-0 z-10">
          <Coffee size={18} strokeWidth={1.5} className="text-amber-600" />
          <span className="text-[11px] font-medium tracking-[0.18em] text-stone-300 uppercase">Signature Coffee Note</span>
        </Link>

        {/* Desktop (md+): horizontal text links — centered absolutely */}
        <div className="hidden md:flex items-center gap-1 absolute left-1/2 -translate-x-1/2">
          {tabs.map(({ path, icon: Icon, label }) => {
            const active = location.pathname === path;
            return (
              <button
                key={path}
                onClick={() => navigate(path)}
                className={cn(
                  'flex items-center gap-1.5 px-3 py-2 text-xs font-medium tracking-widest uppercase transition-colors',
                  active ? 'text-amber-400' : 'text-stone-400 hover:text-stone-200'
                )}
              >
                <Icon size={14} strokeWidth={active ? 2.5 : 1.8} />
                {label}
              </button>
            );
          })}
        </div>



        {/* Mobile (< md): icon tabs */}
        <div className="flex md:hidden items-center justify-around flex-1">
          {tabs.map(({ path, icon: Icon, label }) => {
            const active = location.pathname === path;
            return (
              <button
                key={path}
                onClick={() => navigate(path)}
                className={cn(
                  'flex flex-col items-center justify-center gap-0.5 flex-1 py-2 transition-all bg-transparent border-0',
                  active ? 'text-amber-400' : 'text-stone-500 hover:text-stone-300'
                )}
              >
                <Icon size={20} strokeWidth={active ? 2.5 : 1.8} className={cn('transition-all', active && 'scale-110')} />
                <span className={cn('text-[10px] font-medium tracking-wide', active && 'font-semibold')}>
                  {label}
                </span>
              </button>
            );
          })}
        </div>

      </div>
    </nav>
  );
}